import { exportToCsv } from 'src/services/exports/csv';

export const getDataCsv = (data: any[]) => {
    const groupData: string[][] = [['Case Number', 'Client', 'Date', 'Type', 'Total']];

    data.forEach((itShow) => {
        const dataShow: any = [];
        dataShow.push(itShow.bonusCaseNumber);
        dataShow.push(itShow.bonusInfo);
        dataShow.push(itShow.bonusDate);
        dataShow.push(itShow.bonusType);
        dataShow.push(itShow.amount);
        groupData.push(dataShow);
    });
    const last = data[data.length - 1];
    groupData[data.length] = ['', '', '', '', last.total];

    return exportToCsv('received-bonus-detail.csv', groupData);
};
